import React from 'react';

const StatCard = ({
  icon,
  iconColor = 'purple',
  value,
  label,
  change,
  changeType = 'positive',
}) => {
  return (
    <div className="stat-card">
      <div className="stat-header">
        <div className={`stat-icon ${iconColor}`}>
          <i className={icon}></i>
        </div>
      </div>
      <h2 className="stat-value">{value}</h2>
      <p className="stat-label">{label}</p>
      {change && (
        <div className={`stat-change ${changeType}`}>
          <i className={`bi bi-arrow-${changeType === 'positive' ? 'up' : 'down'}`}></i>
          <span>{change}</span>
        </div>
      )}
    </div>
  );
};

export default StatCard;